// extracted by mini-css-extract-plugin
module.exports = {"grid":"Highlights_grid__3txEh","hideFirst":"Highlights_hideFirst__IjGkn","hideSecond":"Highlights_hideSecond__nvpoe","imageFull":"Highlights_imageFull__E-KSt"};